// frontend/src/components/Signup.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Signup() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [form, setForm] = useState({ username: "", password: "" });
  // const [form, setForm] = useState({ username: "", password: "", role: "Viewer" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(`${baseUrl}/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (data.success) {
        navigate("/");
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Server error. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-white px-4">
      <form
        onSubmit={handleSignup}
        className="w-full max-w-md bg-white rounded-lg shadow-md p-6"
      >
        <img
            src="data:image/jpeg;base64,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"
            alt="Logo"
            className="mx-auto w-24 h-24"
          />
        <h2 className="text-2xl font-bold mb-4 text-center">Sign Up</h2>

        {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
        

        <input
          type="text"
          name="employee_id"
          placeholder="Employee ID"
          className="w-full p-2 border border-gray-300 rounded mb-4"
          value={form.employee_id}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="first_name"
          placeholder="First Name"
          className="w-full p-2 border border-gray-300 rounded mb-4"
          value={form.first_name}
          onChange={handleChange}
          required
        />


        <input
          type="text"
          name="last_name"
          placeholder="Last Name"
          className="w-full p-2 border border-gray-300 rounded mb-4"
          value={form.last_name}
          onChange={handleChange}
          required
        />


        <input
          type="text"
          name="username"
          placeholder="Username"
          className="w-full p-2 border border-gray-300 rounded mb-4"
          value={form.username}
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          className="w-full p-2 border border-gray-300 rounded mb-4"
          value={form.password}
          onChange={handleChange}
          required
        />

        <select
          name="role"
          className="w-full p-2 border border-gray-300 rounded mb-4"
          value={form.role}
          onChange={handleChange}
        >
          <option value="CxO">CxO</option>
          <option value="Admin">Admin</option>
          <option value="Project Manager">Project Manager</option>
          <option value="Finance Manager">Finanace Manager</option>
          <option value="Employee">Employee</option>
        </select>

        <button
          type="submit"
          className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
        >
          Create Account
        </button>

        <p className="mt-4 text-sm text-center">
          Already have an account?{" "}
          <span
            className="text-blue-600 hover:underline cursor-pointer"
            onClick={() => navigate("/")}
          >
            Log in
          </span>
        </p>
      </form>
    </div>
  );
}

export default Signup;
